import { Card, Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { useState } from 'react';

interface SelectionOption {
  id: string;
  title: string;
}

interface SelectionButtonsProps {
  options: SelectionOption[];
  value: string;
  onChange?: (selectedId: string) => void;
}

export default function SelectionButtons({ options, value, onChange }: SelectionButtonsProps) {
  const [selected, setSelected] = useState<string>(value || '');

  const handleSelect = (id: string) => {
    setSelected(id);
    if (onChange) {
      onChange(id);
    }
  };

  const handleCheckboxChange = (e: CheckboxChangeEvent, id: string) => {
    e.stopPropagation();
    handleSelect(id);
  };

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: 12 }}>
      {options.map((option) => {
        const isSelected = selected === option.id;
        return (
          <Card
            key={option.id}
            hoverable
            style={{
              width: '100%',
              backgroundColor: isSelected ? '#426dea' : 'white',
              color: isSelected ? 'white' : 'inherit',
              borderRadius: '8px',
              cursor: 'pointer',
              border: isSelected ? 'none' : '1px solid #e8e8e8',
            }}
            bodyStyle={{ padding: '12px' }}
            onClick={() => handleSelect(option.id)}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{option.title}</div>
              </div>
              {isSelected && (
                <Checkbox
                  checked={true}
                  onChange={(e) => handleCheckboxChange(e, option.id)}
                  style={{ marginLeft: '8px' }}
                />
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
